module.exports = __webpack_public_path__ + "img/joinus-7.f0434457.png";